import { render, staticRenderFns } from "./TheProblem.vue?vue&type=template&id=b801d3b8&"
import script from "./TheProblem.vue?vue&type=script&lang=js&"
export * from "./TheProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports